export const starFilledPath = "<path d=\"M8 2.4 L9.9 6.2 L14 6.8 L11 9.7 L11.6 13.8 L8 12 L4.4 13.8 L5 9.7 L2 6.8 L6.1 6.2 Z\" fill=\"currentColor\"/>"
